module.exports = __webpack_public_path__ + "assets/projects/droplet/edit-project.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/droplet/edit-project.jpg
// module id = 43
// module chunks = 0